import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
	imports: [CommonModule, NgxSpinnerModule],
	declarations: [LoaderComponent],
	entryComponents: [LoaderComponent],
	exports: [LoaderComponent],
	bootstrap: [LoaderComponent],
})
export class BllLoaderModule {}
